import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import "./index.css";
import "./components/Popups.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import ReactDOM from 'react-dom/client';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
